(function () {
  'use strict';
  if (window.__ptRs99u) return;
  window.__ptRs99u = true;
  try { main(); } catch (e) {}

  function main() {
    // ---- tunables -------------------------------------------------------------------------------
    // LIVE VALUE 61 s (GS, 1 Nov 2026; matches the old ATC offer popup).
    var DELAY_MS = 61000;
    var HOLDOUT_PCT = 10;
    var CAMPAIGN = 'rs99-unlock-atc';
    var MIN_PRICE = 9950;               // paise: an Rs 99 cart is never targeted
    var SIZE_GID = { 36: 17216, 37: 3031, 38: 17217, 39: 3034, 40: 17218, 41: 3037 };
    var K_T0 = 'pt_rs99u_t0', K_LINE = 'pt_rs99u_line', K_DONE = 'pt_rs99u_done', K_VID = 'pt_rs99u_vid';

    function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

    // ?rs99u_test=popup | holdout | reset : testing only. popup/holdout force the arm and ignore "once".
    var TEST = '';
    try { TEST = new URLSearchParams(location.search).get('rs99u_test') || ''; } catch (e) {}
    if (TEST === 'reset') { lsDel(K_T0); lsDel(K_LINE); lsDel(K_DONE); TEST = ''; }

    if (lsGet(K_DONE) && !TEST) return;
    if (/^\/collections\/rs-99-store/.test(location.pathname)) return;

    var V = lsGet('pt_visitor_id') || lsGet(K_VID);
    if (!V) { V = 'v' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36); lsSet(K_VID, V); }

    function hash(str) {
      for (var h = 2166136261, i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
      return h % 100;
    }
    var ARM = TEST === 'popup' ? 'popup' : TEST === 'holdout' ? 'holdout' : (hash('rs99u1|' + V) < HOLDOUT_PCT ? 'holdout' : 'popup');

    function track(name, extra) {
      try { (window.dataLayer = window.dataLayer || []).push({ event: name, rs99u_arm: ARM, rs99u_test: TEST || undefined, rs99u: extra || undefined }); } catch (e) {}
      if (!TEST) {
        try {
          navigator.sendBeacon('https://pt-card-collector-cbzg4iqliq-el.a.run.app/collect', new Blob([JSON.stringify({
            type: 'rs99u', event: name.replace('rs99u_', ''), arm: ARM, visitor_id: V,
            size: (extra && extra.size) || null, page: location.pathname, ts: Date.now()
          })], { type: 'text/plain' }));
        } catch (e) {}
      }
    }

    // Single pair, qty 1, above Rs 99, size parsable (36-41). Returns { size, line } or null.
    function eligible(c) {
      if (!c || c.item_count !== 1 || !c.items || c.items.length !== 1) return null;
      var it = c.items[0];
      if (!(it.final_line_price >= MIN_PRICE)) return null;
      var m = / - (3[5-9]|4[01])$/.exec(String(it.title || '').trim());
      if (!m) m = /(?:^|\/\s*)(3[5-9]|4[01])$/.exec(String(it.variant_title || '').trim());
      if (!m) return null;
      return { size: Number(m[1]), line: String(it.key || it.variant_id) };
    }

    function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

    function link(size) {
      var sizes = [size - 1, size, size + 1].filter(function (s) { return SIZE_GID[s]; });
      var f = sizes.map(function (s) { return '&filter.v.t.shopify.shoe-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F' + SIZE_GID[s]; }).join('');
      return '/collections/rs-99-store?filter.v.availability=1' + f + '&utm_source=site&utm_medium=popup&utm_campaign=' + CAMPAIGN +
        '&utm_content=url_rs99&unlock=' + Math.floor(Date.now() / 1000);
    }

    function blocked() {
      try {
        if (document.visibilityState !== 'visible' || document.querySelector('cart-drawer.active') ||
            document.querySelector('.qvm-overlay[aria-hidden="false"]') || document.querySelector('.size-guide.overlay.active')) return true;
        var flo = document.getElementById('flo-cart-overlay-div');
        if (flo && flo.offsetWidth > 0 && flo.offsetHeight > 0 && flo.children.length > 0) return true;
        var f = document.querySelectorAll('iframe[src*="shopflo"]');
        for (var i = 0; i < f.length; i++) { var r = f[i].getBoundingClientRect(); var ow = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0), oh = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0); if (r.width > 50 && r.height > 50 && ow > 50 && oh > 50) return true; }
      } catch (e) {}
      return false;
    }

    // Start (or keep) the clock for the current single-pair cart. A different line restarts it.
    function arm(c) {
      var e = eligible(c);
      if (!e) { lsDel(K_T0); lsDel(K_LINE); return null; }
      if (lsGet(K_LINE) !== e.line || !parseInt(lsGet(K_T0) || '0', 10)) { lsSet(K_LINE, e.line); lsSet(K_T0, String(Date.now())); }
      preload();
      return e;
    }

    // Catch an add-to-cart made on this page (drawer ATC does not reload) and re-arm.
    try {
      var of = window.fetch;
      window.fetch = function (input) {
        var p = of.apply(this, arguments);
        try {
          var u = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(function () { getCart().then(arm).catch(function () {}); }, 400); }).catch(function () {});
        } catch (e) {}
        return p;
      };
    } catch (e) {}

    var IMG = '//www.pairietales.com/cdn/shop/files/2026-09-24_reset_candy_pink_new_arrivals_separator_1396x1042_1bdf7ba7-76c5-46d3-89d1-9c19dca956be.png?width=680';   // full figure; caption sits in the right quarter, cropped out
    var CSS = '.pt-r9{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;background:rgba(18,18,18,.55);opacity:0;transition:opacity .2s;font-family:var(--font-body-family,Montserrat,system-ui,sans-serif);-webkit-font-smoothing:antialiased}' +
      '.pt-r9.is-in{opacity:1}' +
      '.pt-r9__p{position:relative;width:340px;max-width:100%;max-height:100%;overflow:auto;background:#121212;color:#fff;border-radius:12px;padding:0 24px 20px;text-align:center;box-sizing:border-box;transform:scale(.96);transition:transform .2s}' +
      '.pt-r9.is-in .pt-r9__p{transform:none}' +
      '.pt-r9__i{aspect-ratio:1/1;margin:0 -24px 16px;overflow:hidden;background:#222}.pt-r9__i img{display:block;width:133.4%;max-width:none;height:100%;object-fit:cover;object-position:0% 50%}' +
      '.pt-r9__x{position:absolute;top:8px;right:8px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(18,18,18,.55);color:#fff;font:400 24px/1 system-ui,sans-serif;cursor:pointer}' +
      '.pt-r9__l{font-size:10px;font-weight:700;letter-spacing:1.6px;text-transform:uppercase;color:#cadb2a}' +
      '.pt-r9__h{font-size:clamp(15px,5vw,19px);font-weight:800;line-height:1.15;margin:8px 0 0;color:#fff;white-space:nowrap}' +
      '.pt-r9__s{font-size:clamp(11px,3.6vw,13px);line-height:1.4;margin:8px 0 0;color:#e6e6e6;white-space:nowrap}' +
      '.pt-r9__b{display:block;width:100%;min-height:48px;border:0;border-radius:8px;background:#cadb2a;color:#000;font:700 13px var(--font-body-family,Montserrat,system-ui,sans-serif);letter-spacing:.4px;cursor:pointer;margin-top:16px;text-decoration:none;line-height:48px}' +
      '.pt-r9__f{font-size:11px;color:#bdbdbd;margin-top:10px;letter-spacing:.3px}' +
      '@media(prefers-reduced-motion:reduce){.pt-r9,.pt-r9__p{transition:none}}';


    // Fetch and decode the popup image as soon as the clock starts, so it is in the cache long before it shows.
    var preloaded = false;
    function preload() {
      if (preloaded) return;
      preloaded = true;
      try { var im = new Image(); im.src = IMG; if (im.decode) im.decode().catch(function () {}); } catch (e) {}
    }

    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

    function show(size) {
      var style = el('style'); style.textContent = CSS; document.head.appendChild(style);
      var root = el('div', 'pt-r9'); root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', '₹99 Store unlocked');
      var p = el('div', 'pt-r9__p');
      var x = el('button', 'pt-r9__x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Close');
      var cta = el('a', 'pt-r9__b', 'SHOP MY SIZE AT ₹99'); cta.href = link(size);
      var im = el('div', 'pt-r9__i'), img = el('img'); img.src = IMG; img.alt = ''; im.appendChild(img);
      p.appendChild(im); p.appendChild(x);
      p.appendChild(el('div', 'pt-r9__l', 'Just for you'));
      p.appendChild(el('div', 'pt-r9__h', 'Your ₹99 Store is unlocked'));
      p.appendChild(el('div', 'pt-r9__s', 'Open for 24 hours.'));
      p.appendChild(cta);
      p.appendChild(el('div', 'pt-r9__f', 'Your cart stays as it is.'));
      root.appendChild(p); document.body.appendChild(root);
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
      function close() { document.removeEventListener('keydown', onKey); root.classList.remove('is-in'); setTimeout(function () { try { root.remove(); style.remove(); } catch (e) {} }, 320); }
      function onKey(e) { if (e.key === 'Escape') { track('rs99u_closed'); close(); } }
      document.addEventListener('keydown', onKey);
      x.addEventListener('click', function () { track('rs99u_closed'); close(); });
      root.addEventListener('click', function (e) { if (e.target === root) { track('rs99u_closed'); close(); } });
      cta.addEventListener('click', function () { track('rs99u_click', { size: size }); });
      track('rs99u_shown', { size: size });
    }

    function fire(e) {
      lsSet(K_DONE, '1');                       // once per visitor, shown or held out
      if (ARM === 'holdout') { track('rs99u_holdout', { size: e.size }); return; }
      show(e.size);
    }

    var tries = 0;
    var timer;
    function check() {
      var t0 = parseInt(lsGet(K_T0) || '0', 10);
      if (!t0) return;
      if (Date.now() - t0 < DELAY_MS) return;
      if (blocked()) { if (++tries > 120) clearInterval(timer); return; }   // wait, ask again on the next tick
      clearInterval(timer);
      getCart().then(function (c) { var e = eligible(c); if (e) fire(e); else { lsDel(K_T0); lsDel(K_LINE); } }).catch(function () {});
    }

    getCart().then(arm).catch(function () {});
    timer = setInterval(check, 5000);
  }
})();
